/**
 * Set a cookie with expiration in seconds.
 * Uses Secure flag in production and SameSite=Lax for CSRF protection.
 *
 * @param name - Cookie name
 * @param value - Cookie value
 * @param expiresInSeconds - Expiration time in seconds (e.g., 900 = 15 min, 2592000 = 30 days)
 */
export const setCookie = (
  name: string,
  value: string,
  expiresInSeconds?: number,
) => {
  let expires = "";
  if (expiresInSeconds) {
    const date = new Date();
    date.setTime(date.getTime() + expiresInSeconds * 1000);
    expires = "; expires=" + date.toUTCString();
  }

  const isProduction = window.location.protocol === "https:";
  const secure = isProduction ? "; secure" : "";

  document.cookie =
    name + "=" + (value || "") + expires + "; path=/; samesite=lax" + secure;
};

export const getCookie = (name: string) => {
  const nameEQ = name + "=";
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

export const eraseCookie = (name: string) => {
  document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
};
